import { render, staticRenderFns } from "./TopDashboard.vue?vue&type=template&id=5877d8f6&scoped=true"
import script from "./TopDashboard.vue?vue&type=script&lang=js"
export * from "./TopDashboard.vue?vue&type=script&lang=js"
import style0 from "./TopDashboard.vue?vue&type=style&index=0&id=5877d8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877d8f6",
  null
  
)

export default component.exports